import {loginFetch, get, post} from '@/utils/fetch'

export function loginByUserName(username, password,time,vcode) {
  const data = {
    username,
    password,
    time,
    vcode
  };
  return loginFetch({
    url: '/login',
    data
  })
}

export function getIndex() {
  return get({
    url: 'manage/pub/find'
  })
}
export function getInfo() {
  return get({
    url: 'manage/sys/iportal/userinfo'
  })
}

export function getMenu() {
  return get({
    url: 'manage/sys/iportal/menulist?appId=3&isShow=1'
  })
}

export function cancel() {
  return get({
    url: 'manage/sys/user/analog/1/1'
  })
}

export function logout(nodeId) {
  return post({
    url: 'manage/pub/loginout?nodeId='+nodeId
  })
}

export function getNeedMobile() {
  return get({
    url: 'manage/pub/getConfig'
  })
}

export function sendMail(data) {
  return post({
    url: 'manage/pub/sendMail',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js